module.exports = __webpack_public_path__ + "static/img/teacher_4.ef8b410.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher_4.jpg
// module id = 3dja
// module chunks = 1